module.exports = {
  purge: ['./src/**/*.{js,jsx,ts,tsx}', './public/index.html'],
  darkMode: false, // or 'media' or 'class'
  theme: {
    colors: {
      content: {
        DEFAULT: '#36393D',
      },
      primary: {
        DEFAULT: '#E32326',
        dark: '#ca1a1d',
      },
      secondary: {
        DEFAULT: '#3A3A3A',
      },
      color1: {
        DEFAULT: '#4A4A4A',
      },
      color2: {
        DEFAULT: '#342D22',
      },
      gray: {
        light: '#e2e5e2',
        DEFAULT: '#B9B7B7',
        dark: '#979797',
      },
      white: {
        DEFAULT: '#ffffff',
      },
      black: {
        DEFAULT: '#000000',
      },
      red: {
        DEFAULT: '#ff0000',
      },
      blue: {
        DEFAULT: '#00579A',
      },
      purple: {
        DEFAULT: '#7D4299',
      },
    },
    backgroundColor: (theme) => ({
      ...theme('colors'),
    }),
    fontSize: {
      xs: ['11px', '16px'],
      sm: ['13px', '18px'],
      base: ['18px', '26px'],
      h1: ['70px', '90px'],
      'h1-mobile': ['70px', '90px'],
      h2: ['40px', '50px'],
      'h2-mobile': ['28px', '40px'],
      h3: ['28px', '40px'],
      'h3-mobile': ['20px', '26px'],
      h4: ['26px', '40px'],
      'h4-mobile': ['18px', '26px'],
      14: ['14px', '18px'],
      16: ['16px', '24px'],
      18: ['18px', '24px'],
      21: ['21px', '24px'],
      24: ['24px', '34px'],
      25: ['25px', '40px'],
      26: ['26px', '40px'],
      28: ['28px', '40px'],
      30: ['30px', '55px'],
      35: ['35px', '55px'],
      40: ['40px', '55px'],
      45: ['45px', '55px'],
      64: ['64px', '75px'],
      lg: ['24px', '36px'],
      xl: ['47px', '60px'],
      '2xl': ['70px', '90px'],
      120: ['120px', '150px'],
    },
    fontFamily: {
      primary: ['proxima-nova', 'sans-serif'],
      secondary: ['erbaum', 'serif'],
    },
    zIndex: {
      0: 0,
      10: 10,
      20: 20,
      30: 30,
      40: 40,
      50: 50,
      60: 60,
      70: 70,
      80: 80,
      90: 90,
      100: 100,
    },
    container: {
      center: true,
      screens: {
        xl: '1170px',
      },
    },
    screens: {
      xs: '476px',
      sm: '640px',
      md: '769px',
      lg: '1024px',
      xl: '1200px',
      '2xl': '1536px',
    },
  },
  variants: {
    extend: {
      display: ['group-hover'],
      borderStyle: ['last'],
      margin: ['last'],
      padding: ['last'],
    },
  },
};
